import React from "react";

function SynthesisIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 21 21">
      <g transform="translate(24464 23842)">
        <g transform="translate(-24464 -23842)" fill="none" strokeWidth="1.75">
          <rect width="10" height="9" rx="2" stroke="none" />
          <rect
            x="0.875"
            y="0.875"
            width="8.25"
            height="7.25"
            rx="1.125"
            fill="none"
          />
        </g>
        <g transform="translate(-24464 -23832)" fill="none" strokeWidth="1.75">
          <rect width="10" height="11" rx="2" stroke="none" />
          <rect
            x="0.875"
            y="0.875"
            width="8.25"
            height="9.25"
            rx="1.125"
            fill="none"
          />
        </g>
        <g transform="translate(-24453 -23842)" fill="none" strokeWidth="1.75">
          <rect width="10" height="21" rx="2" stroke="none" />
          <rect
            x="0.875"
            y="0.875"
            width="8.25"
            height="19.25"
            rx="1.125"
            fill="none"
          />
        </g>
      </g>
    </svg>
  );
}

export { SynthesisIcon };
